const support = (): void => {
  // モーダル情報を取得
  const modal: HTMLElement | null = document.querySelector('.p-support-modal');
  const modalIcon: HTMLElement | null = document.querySelector('.p-support-modal__icon img');
  const modalTitle: HTMLElement | null = document.querySelector('.p-support-modal__title');
  const modalContents: HTMLElement | null = document.querySelector('.p-support-modal__contents');
  const modalButton1: HTMLAnchorElement | null = document.querySelector('.p-support-modal__buttons .button1');
  const modalButton2: HTMLAnchorElement | null = document.querySelector('.p-support-modal__buttons .button2');

  const modalLinks: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('.p-support-list__item');

  // モーダルを開く
  modalLinks.forEach((item: HTMLAnchorElement) => {
    const iconSrc: string = item.querySelector('.p-support-list__icon img')?.getAttribute('src') || '';
    const title: string = item.getAttribute('data-title') || '';
    const contents: string = item.getAttribute('data-contents') || '';
    const link1: string = item.getAttribute('data-link1') || '';
    const target1: string = item.getAttribute('data-target1') || '';
    const link2: string = item.getAttribute('data-link2') || '';
    const target2: string = item.getAttribute('data-target2') || '';

    item?.addEventListener('click', (e: Event) => {
      modal?.classList.add('is-active');
      modalIcon?.setAttribute('src', iconSrc);
      if (modalTitle !== null) {
        modalTitle.innerHTML = title;
      }
      if (modalContents !== null) {
        modalContents.innerHTML = contents;
      }
      modalButton1?.setAttribute('href', link1);
      modalButton1?.setAttribute('target', target1);
      modalButton2?.setAttribute('href', link2);
      modalButton2?.setAttribute('target', target2);

      modal?.classList.add('is-active');
    });
  });

  // モーダルを閉じる
  const modalClose1: HTMLElement | null = document.querySelector('.p-support-modal__close');
  const modalClose2: HTMLElement | null = document.querySelector('.p-support-modal__buttons .button3');
  modalClose1?.addEventListener('click', () => modal?.classList.remove('is-active'));
  modalClose2?.addEventListener('click', () => modal?.classList.remove('is-active'));

  // ページ読み込み時、ハッシュ値があれあば、該当のモーダルを表示
  addEventListener('load', () => {
    const hash: string = location.hash;
    const target: HTMLElement | null = document.getElementById(hash.replace('#', ''));
    console.log(target);
    if (target !== null) {
      target.click();
    }
  });
};

export default support;
